import React from "react"
import styled from "@emotion/styled"
import { css } from "@emotion/react"
import { StaticImage } from "gatsby-plugin-image"
import { Spring } from "react-spring/renderprops"

import { slideInSpringProps } from "../../services/helpers"
import VisibilitySensor from "../visibility-sensor"
import Euro from "../../assets/euro.inline.svg"
import RawMaterial from "../../assets/raw-material.inline.svg"
import ShoppingCart from "../../assets/shopping-cart.inline.svg"
import theme from "../../styles/theme"

const Advantages = ({ className }) => {
  return (
    <section className={className}>
      <div className="inner grid grid-section">
        <div className="centered-grid-element">
          <StaticImage
            imgStyle={{
              borderRadius: theme.shape.borderRadius[0],
              boxShadow: theme.elevation.level2,
            }}
            css={css`
              border-radius: ${theme.shape.borderRadius[0]};
              box-shadow: ${theme.elevation.level2};
            `}
            placeholder="blurred"
            width={260}
            src="../../images/index_avantages.jpg"
            alt=""
          />
        </div>
        <div className="centered-grid-element">
          <StyledList>
            <VisibilitySensor once partialVisibility>
              {({ isVisible }) => (
                <Spring {...slideInSpringProps(isVisible, 300, true)}>
                  {props => (
                    <StyledLine style={{ ...props }}>
                      <StyledIcon>
                        <Euro />
                      </StyledIcon>
                      <StyledText>
                        <div className="h4 medium">Du pouvoir d'achat</div>
                        <div>
                          <span>À toi "le formidable"</span> qui auras permis de
                          le collecter
                        </div>
                      </StyledText>
                    </StyledLine>
                  )}
                </Spring>
              )}
            </VisibilitySensor>
            <VisibilitySensor once partialVisibility>
              {({ isVisible }) => (
                <Spring {...slideInSpringProps(isVisible, 600, true)}>
                  {props => (
                    <StyledLine style={{ ...props }}>
                      <StyledIcon>
                        <ShoppingCart />
                      </StyledIcon>
                      <StyledText>
                        <div className="h4 medium">De nouveaux clients</div>
                        <div>
                          Au magasin <span>"héroïque"</span> chez qui tu l'auras
                          remis
                        </div>
                      </StyledText>
                    </StyledLine>
                  )}
                </Spring>
              )}
            </VisibilitySensor>
            <VisibilitySensor once partialVisibility>
              {({ isVisible }) => (
                <Spring {...slideInSpringProps(isVisible, 900, true)}>
                  {props => (
                    <StyledLine style={{ ...props }}>
                      <StyledIcon>
                        <RawMaterial />
                      </StyledIcon>
                      <StyledText>
                        <div className="h4 medium">De la matière première</div>
                        <div>
                          À l'artisan
                          <span>"transformateur"</span> qui lui donnera une
                          nouvelle vie
                        </div>
                      </StyledText>
                    </StyledLine>
                  )}
                </Spring>
              )}
            </VisibilitySensor>
          </StyledList>
        </div>
      </div>
    </section>
  )
}

const StyledLine = styled.li`
  display: flex;
  align-items: center;
  margin-bottom: 1em;
  &:last-of-type {
    margin-bottom: 0;
  }
`
const StyledIcon = styled.div`
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: ${theme.palette.common.white};
  border-radius: 50%;
  width: 80px;
  height: 80px;
  margin-right: 1rem;
`
const StyledText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

const StyledList = styled.ul`
  color: ${theme.palette.common.black};
  margin: auto;
`

export default Advantages
